import React, { Fragment } from 'react'

const Design = () => {
    return (
        <Fragment>
            <h2>Design</h2>
            <p>
                The effectiveness of a design is not only an art, but a science.
                There are many principles of NLP and psychology that goes into
                the planning and execution of the final design. Our team also
                uses principles used in marketing from past sales experience to
                influence users to engage with our clients products.
            </p>
            <p>Getting your design is a simple process:</p>
            <ol>
                <li>
                    Meet with one of our developers/designers to consult about
                    your dream application.
                </li>
                <li>Review wireframes of potential layout.</li>
                <li>
                    Approve a high-fidelity mock up of your new application.
                </li>
            </ol>
            <p>
                Once we have your design completed, our developers will guide
                you through the process of bringing this design to life.
            </p>
        </Fragment>
    )
}

export default Design
